import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { Resolve } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';
import { catchError, take } from 'rxjs/operators';

import { VersionService } from '../services';

/**
 *
 * @export
 */
@Injectable({ providedIn: 'root' })
export class AuthenticationTranslationsResolver implements Resolve<any> {
    private appVersion: string;

    constructor(
        @Inject(LOCALE_ID) private localeCode: string,
        private http: HttpClient,
        private translate: TranslateService,
        versionService: VersionService
    ) {
        this.appVersion = versionService.getAppVersion();
    }

    resolve(): Promise<any> {
        return new Promise((resolve, _) => {
            this.http
                .get('/assets/i18n/' + this.localeCode + `.json?cacheBuster=${this.appVersion}`)
                .pipe(
                    take(1),
                    catchError((error) => {
                        return of([]);
                    })
                )
                .toPromise()
                .then((currentStaticTranslationContent: any) => {
                    this.translate.setTranslation(this.localeCode, currentStaticTranslationContent);
                    this.translate.use(this.localeCode);

                    resolve(currentStaticTranslationContent);
                });
        });
    }
}
